import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaPhone, FaWhatsapp, FaInstagram, FaMapMarkerAlt, FaClock, FaDirections, FaInfoCircle } from 'react-icons/fa';
import Logo from '../../assets/logo.png';
import { branchesData } from '../../data/branchesData';

const Footer = () => {
  return (
    <footer className="relative bg-[#090a0e] text-white pt-12 md:pt-16 pb-6 md:pb-8 px-4 md:px-10 overflow-hidden border-t border-red-600/30 mt-16 select-none">
      {/* Ambient background glows */}
      <div className="absolute w-96 h-96 bg-red-600/15 blur-[180px] rounded-full top-0 left-0 pointer-events-none -z-0" />
      <div className="absolute w-96 h-96 bg-red-800/15 blur-[180px] rounded-full bottom-0 right-0 pointer-events-none -z-0" />

      {/* ── TOP MOTTO BANNER ── */}
      <div className="relative z-10 max-w-7xl mx-auto mb-12 bg-gradient-to-r from-red-600/15 via-[#161822] to-red-600/15 p-6 rounded-3xl border border-red-500/30 backdrop-blur-xl flex flex-col md:flex-row items-center justify-between gap-6 shadow-2xl">
        <div className="flex flex-col text-center md:text-left">
          <span className="text-red-500 font-extrabold uppercase text-xs tracking-[0.3em] mb-1">
            Science-Backed Training System
          </span>
          <h2 className="text-2xl sm:text-4xl font-black uppercase text-white tracking-wide">
            BE YOUR <span className="text-red-500">OWN IDOL</span>
          </h2>
        </div>

        {/* Pillars Chips */}
        <div className="flex flex-wrap justify-center gap-2">
          {['Training', 'Coaching', 'Nutrition', 'Transformations'].map((pillar, i) => (
            <span
              key={i}
              className="bg-white/5 border border-white/10 text-gray-200 hover:text-white hover:border-red-500/40 text-xs font-bold uppercase tracking-wider px-3.5 py-1.5 rounded-full backdrop-blur-md transition-colors"
            >
              • {pillar}
            </span>
          ))}
        </div>
      </div>

      {/* ── MAIN FOOTER BENTO GRID ── */}
      <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6 md:gap-8 max-w-7xl mx-auto pb-10 border-b border-white/10">
        
        {/* Col 1: Brand & Bio (4 Cols) */}
        <div className="lg:col-span-4 flex flex-col gap-4">
          <NavLink to="/" className="flex items-center gap-2.5 group">
            <img src={Logo} alt="IDOL FITNESS ZONE" className="h-10 w-auto object-contain transition-transform group-hover:scale-105" />
            <div className="flex flex-col">
              <span className="text-base font-black tracking-wider uppercase text-white leading-none group-hover:text-red-500 transition-colors">
                IDOL FITNESS <span className="text-red-500">ZONE</span>
              </span>
              <span className="text-[9px] uppercase tracking-[0.25em] text-red-400 font-bold mt-0.5">
                Coimbatore • 3 Locations
              </span>
            </div>
          </NavLink>

          <p className="text-gray-300 text-xs leading-relaxed max-w-sm">
            IDOL Fitness Zone is built around structured training, professional coaching and long-term progress. We teach members how to train effectively with science-backed methodology.
          </p>

          {/* Quick Nav Links */}
          <div className="flex flex-wrap gap-3 text-xs pt-1">
            <NavLink to="/about" className="text-gray-300 hover:text-red-400 font-semibold transition-colors">About</NavLink>
            <span className="text-gray-600">•</span>
            <NavLink to="/explore" className="text-gray-300 hover:text-red-400 font-semibold transition-colors">Explore</NavLink>
            <span className="text-gray-600">•</span>
            <NavLink to="/packages" className="text-gray-300 hover:text-red-400 font-semibold transition-colors">Packages</NavLink>
            <span className="text-gray-600">•</span>
            <NavLink to="/equipments" className="text-gray-300 hover:text-red-400 font-semibold transition-colors">My@Idol</NavLink>
            <span className="text-gray-600">•</span>
            <NavLink to="/contact" className="text-gray-300 hover:text-red-400 font-semibold transition-colors">Contact</NavLink>
          </div>

          {/* Micro Instagram Chips */}
          <div className="flex flex-col gap-1.5 pt-1">
            <span className="text-[10px] font-extrabold uppercase tracking-wider text-red-400">Official Social Channels:</span>
            <div className="flex flex-wrap gap-2">
              <a
                href="https://www.instagram.com/idol_fitness_zone?igsi=MXFnYm40aXR3a2d1Ng=="
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 bg-white/5 hover:bg-red-600/20 border border-white/10 hover:border-red-500/40 px-2.5 py-1 rounded-lg text-[10px] font-semibold text-gray-300 hover:text-white transition-all"
              >
                <FaInstagram className="text-red-500" /> Instagram Unit 1
              </a>
              <a
                href="https://www.instagram.com/idol_fitnesszone2?utm_source=qr&igsi=enFwMHRpbGxwYmQw"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 bg-white/5 hover:bg-red-600/20 border border-white/10 hover:border-red-500/40 px-2.5 py-1 rounded-lg text-[10px] font-semibold text-gray-300 hover:text-white transition-all"
              >
                <FaInstagram className="text-red-500" /> Instagram Unit 2
              </a>
            </div>
          </div>
        </div>

        {/* Col 2: 3 Units Showcase (5 Cols) */}
        <div className="lg:col-span-5 flex flex-col gap-3">
          <div className="flex items-center justify-between pb-1 border-b border-red-600/30">
            <span className="text-xs font-black text-white uppercase tracking-wider flex items-center gap-1.5">
              <FaMapMarkerAlt className="text-red-500" /> 3 Coimbatore Locations
            </span>
            <span className="text-[9px] text-gray-400 uppercase font-semibold">Universal Access</span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
            {branchesData.map((branch) => (
              <div
                key={branch.id}
                className="bg-[#14161f]/90 hover:bg-[#181a24] p-3 rounded-xl border border-white/10 hover:border-red-500/40 transition-all flex flex-col justify-between group shadow-md"
              >
                <div>
                  <div className="flex items-center justify-between gap-1 mb-1.5">
                    <span className="text-[9px] font-black uppercase text-red-500 bg-red-600/15 px-2 py-0.5 rounded-md border border-red-500/20">
                      {branch.unitNumber}
                    </span>
                    <span className="text-[8px] text-gray-400 uppercase font-semibold">
                      {branch.badge}
                    </span>
                  </div>

                  <h5 className="text-xs font-bold text-white mb-1 group-hover:text-red-400 transition-colors leading-tight">
                    {branch.name}
                  </h5>
                  <p className="text-[10px] text-gray-400 leading-snug line-clamp-2 mb-2">
                    {branch.address}
                  </p>
                </div>

                <div className="flex flex-col gap-1 pt-1.5 border-t border-white/10">
                  <a
                    href={branch.mapsUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center justify-center gap-1 bg-red-600/20 hover:bg-red-600 text-red-400 hover:text-white text-[9px] font-bold py-1 px-2 rounded-lg transition-all"
                  >
                    <FaDirections /> Maps ↗
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Col 3: Quick Links & Coaches (3 Cols) */}
        <div className="lg:col-span-3 flex flex-col gap-3">
          <span className="text-xs font-black text-white uppercase tracking-wider pb-1 border-b border-red-600/30">
            Coaches & WhatsApp
          </span>

          <div className="flex flex-col gap-2 text-xs">
            {/* Working Hours */}
            <div className="flex items-center gap-2 text-[10px] text-gray-300 bg-white/5 p-2 rounded-xl border border-white/5">
              <FaClock className="text-red-500 text-xs flex-shrink-0" />
              <span>Mon–Sat: 5:00 AM – 10:00 PM</span>
            </div>

            {/* Manager Sanjay */}
            <div className="bg-white/5 p-2.5 rounded-xl border border-white/10 flex flex-col gap-1">
              <span className="text-[9px] font-extrabold text-red-400 uppercase tracking-wider">Manager — Sanjay</span>
              <div className="flex items-center justify-between text-[10px]">
                <a href="tel:7339504861" className="text-gray-300 hover:text-white flex items-center gap-1 font-semibold">
                  <FaPhone className="text-[9px] text-red-500" /> 73395 04861
                </a>
                <a href="https://wa.me/917339504861" target="_blank" rel="noreferrer" className="text-green-400 hover:underline flex items-center gap-1 text-[9px] font-bold">
                  <FaWhatsapp /> WhatsApp
                </a>
              </div>
            </div>

            {/* Trainer Karthikeyan */}
            <div className="bg-white/5 p-2.5 rounded-xl border border-white/10 flex flex-col gap-1">
              <span className="text-[9px] font-extrabold text-red-400 uppercase tracking-wider">Trainer — Karthikeyan</span>
              <div className="flex items-center justify-between text-[10px]">
                <a href="tel:9047477177" className="text-gray-300 hover:text-white flex items-center gap-1 font-semibold">
                  <FaPhone className="text-[9px] text-red-500" /> 90474 77177
                </a>
                <a href="https://wa.me/919047477177" target="_blank" rel="noreferrer" className="text-green-400 hover:underline flex items-center gap-1 text-[9px] font-bold">
                  <FaWhatsapp /> WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── INDIVIDUALIZED PROGRAMMING DISCLAIMER NOTE ── */}
      <div className="relative z-10 max-w-7xl mx-auto my-6 bg-white/5 p-4 rounded-2xl border border-white/10 flex items-start gap-3 text-xs text-gray-300">
        <FaInfoCircle className="text-red-500 text-lg flex-shrink-0 mt-0.5" />
        <p className="leading-relaxed text-[11px] sm:text-xs text-gray-300">
          <strong className="text-white font-bold">Important:</strong> The workout plans in this website blueprint are example structures for the Explore section. Actual programming should be individualized according to the person's goals, experience, training history, equipment, recovery and other relevant factors.
        </p>
      </div>

      {/* ── BOTTOM COPYRIGHT STRIP ── */}
      <div className="relative z-10 pt-4 flex flex-col sm:flex-row items-center justify-between text-[10px] text-gray-500 max-w-7xl mx-auto gap-3">
        <p>© {new Date().getFullYear()} <strong className="text-red-500">IDOL FITNESS ZONE</strong>. All rights reserved. Designed by <strong className="text-red-500"><span >Dilipkumar</span></strong></p>
        <div className="flex items-center gap-3 text-[9px] text-gray-400">
          <span>Unit 1: Chettipalayam JJ Nagar</span>
          <span className="text-gray-700">•</span>
          <span>Unit 2: Pappampatti Pirivu</span>
          <span className="text-gray-700">•</span>
          <span>Unit 3: Peedampalli</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;